@if (!baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">North Dakota</h2>
  @if (baseRules?.noSelection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ controls[0].label }}</label>
    </div>
  }
}
